import { IProductCardData } from "../components";
import { mockedPricesMainOnly } from "./price";
import { deepClone } from "../helpers";

export const productCardData: IProductCardData<HTMLLinkElement> = {
  id: "111",
  colors: ["black", "white", "red", "green", "gray", "red", "red"],
  favorite: false,

  description: {
    product: {
      text: "Nike Revolution 5 BQ3204 men's running shoe",
      href: "/",
    },
    brand: {
      text: "Nike",
      href: "/",
    },
    sports: {
      text: "Running",
    },
  },

  productItems: [
    {
      id: "1",
      image: {
        src: "assets/images/1.jpg",
      },
      badges: [
        {
          text: "Best Choice",
          color: "blue",
        },
        { text: "-20%", color: "red" },
        { text: "Recyclable", color: "green" },
      ],
      feedback: {
        reviews: 15,
        rating: 4.5,
      },
      prices: [
        {
          price: "20",
          currency: "€",
        },
        {
          price: "50",
          currency: "€",
          variant: "original",
        },
      ],
    },
    {
      id: "2",
      image: {
        src: "assets/images/2.jpg",
      },
      badges: [
        {
          text: "Best Choice",
          color: "blue",
        },
        { text: "-10%", color: "red" },
      ],
      feedback: {
        reviews: 100,
        rating: 4,
      },
      prices: [
        {
          price: "10",
          currency: "€",
        },
        {
          price: "50",
          currency: "€",
          variant: "original",
        },
      ],
    },
    {
      id: "3",
      image: {
        src: "assets/images/3.jpg",
        alt: "my own alt",
      },
      badges: [
        {
          text: "Best Choice",
          color: "blue",
        },
      ],
      feedback: {
        reviews: 29,
        rating: 3.8,
      },
      prices: [
        {
          price: "50",
          currency: "€",
        },
      ],
    },
    {
      id: "4",
      image: {
        src: "assets/images/4.jpg",
        alt: "my own alt",
      },
      badges: [{ text: "-39%", color: "red" }],
      feedback: {
        reviews: 10,
        rating: 5,
      },
      prices: [
        {
          price: "39",
          currency: "€",
        },
        {
          price: "50",
          currency: "€",
          variant: "original",
        },
      ],
    },
    {
      id: "5",
      image: {
        src: "assets/images/5.jpg",
      },
      badges: [],
      feedback: {
        reviews: null,
        rating: null,
      },
      prices: [
        {
          price: "100",
          currency: "€",
        },
      ],
    },
    {
      id: "6",
      image: {
        src: "assets/images/6.jpg",
      },
      badges: [{ text: "Promo", color: "black" }],
      feedback: {
        reviews: 18,
        rating: 4.8,
      },
      prices: [
        {
          price: "40",
          currency: "€",
        },
        {
          price: "50",
          currency: "€",
          variant: "original",
        },
      ],
    },
    {
      id: "7",
      image: {
        src: "assets/images/7.jpg",
      },
      badges: [
        { text: "Promo", color: "black" },
        { text: "-15%", color: "red" },
      ],
      feedback: {
        reviews: 60,
        rating: 4.2,
      },
      prices: [
        {
          price: "15",
          currency: "€",
        },
        {
          price: "50",
          currency: "€",
          variant: "original",
        },
      ],
    },
    {
      id: "8",
      image: {
        src: "assets/images/8.jpg",
      },
      badges: [
        {
          text: "Best Choice",
          color: "blue",
        },
        { text: "Promo", color: "black" },
        { text: "-10%", color: "red" },
      ],
      feedback: {
        reviews: 15,
        rating: 4.5,
      },
      prices: [
        {
          price: "10",
          currency: "€",
        },
        {
          price: "50",
          currency: "€",
          variant: "original",
        },
      ],
    },
  ],
};

export const productCardsListData: IProductCardData<HTMLLinkElement>[] = [
  {
    id: "1",
    colors: [
      "black",
      "white",
      "green",
      "gray",
      "red",
      "#ccc",
      "#d51",
      "#153",
      "rgba(255,0,225)",
    ],
    favorite: false,
    description: {
      product: {
        text: "Nike Revolution 5 BQ3205 men's running shoe",
      },
      brand: {
        text: "Nike",
      },
      sports: {
        text: "Running",
      },
    },
    productItems: [
      {
        id: "1",
        image: {
          src: "assets/images/2.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "2",

        image: {
          src: "assets/images/1.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "3",
        image: {
          src: "assets/images/3.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "4",
        image: {
          src: "assets/images/5.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "5",
        image: {
          src: "assets/images/4.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "6",
        image: {
          src: "assets/images/6.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "7",
        image: {
          src: "assets/images/5.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "8",
        image: {
          src: "assets/images/5.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
    ],
    linkParams: {
      href: "/1",
      hreflang: "en",
    },
  },
  {
    id: "2",
    colors: ["black", "white", "red", "green", "gray", "red"],
    favorite: true,

    description: {
      product: {
        text: "Nike Revolution 5 BQ3206 men's running shoe",
      },
      brand: {
        text: "Nike",
      },
      sports: {
        text: "Running",
      },
    },

    productItems: [
      {
        id: "1",
        image: {
          src: "assets/images/2.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "2",
        image: {
          src: "assets/images/5.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "3",
        image: {
          src: "assets/images/5.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "4",

        image: {
          src: "assets/images/5.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "5",

        image: {
          src: "assets/images/5.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "6",

        image: {
          src: "assets/images/5.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
    ],
  },
  {
    id: "3",
    colors: [
      "black",
      "white",
      "red",
      "green",
      "gray",
      "red",
      "red",
      "red",
      "red",
    ],
    favorite: false,

    description: {
      product: {
        text: "Nike Revolution 5 BQ3207 men's running shoe",
      },
      brand: {
        text: "Nike",
      },
      sports: {
        text: "Running",
      },
    },

    productItems: [
      {
        id: "1",
        image: {
          src: "assets/images/3.jpg",
        },
        badges: [
          {
            text: "-50%",
            color: "red",
          },
        ],
        feedback: {
          reviews: 155,
          rating: 3.5,
        },
        prices: [
          {
            price: "50",
            currency: "€",
          },
          {
            price: "95",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "2",
        image: {
          src: "assets/images/5.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "3",
        image: {
          src: "assets/images/5.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-50%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "50",
            currency: "€",
          },
          {
            price: "112",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "4",
        image: {
          src: "assets/images/5.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "5",
        image: {
          src: "assets/images/5.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "6",
        image: {
          src: "assets/images/5.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
    ],
  },
  {
    id: "4",
    colors: ["black", "white", "green"],
    favorite: false,

    description: {
      product: {
        text: "Nike Revolution 5 BQ3208 men's running shoe",
      },
      brand: {
        text: "Nike",
      },
      sports: {
        text: "Running",
      },
    },

    productItems: [
      {
        id: "1",
        image: {
          src: "assets/images/4.jpg",
        },
        badges: [],
        feedback: {
          reviews: 29,
          rating: 5,
        },
        prices: [
          {
            price: "121",
            currency: "€",
          },
        ],
      },
      {
        id: "2",
        image: {
          src: "assets/images/5.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-50%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "50",
            currency: "€",
          },
          {
            price: "220",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "3",
        image: {
          src: "assets/images/5.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "4",
        image: {
          src: "assets/images/5.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
    ],
  },
  {
    id: "5",
    colors: ["black", "white", "red", "green", "gray", "red", "red"],
    favorite: false,

    description: {
      product: {
        text: "Nike Revolution 5 BQ3209 men's running shoe",
      },
      brand: {
        text: "Nike",
      },
      sports: {
        text: "Running",
      },
    },

    productItems: [
      {
        id: "1",
        image: {
          src: "assets/images/2.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: null,
          rating: null,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "2",
        image: {
          src: "assets/images/5.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 10,
          rating: 4,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "3",
        image: {
          src: "assets/images/5.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "4",
        image: {
          src: "assets/images/5.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "5",
        image: {
          src: "assets/images/5.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "6",
        image: {
          src: "assets/images/5.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "7",
        image: {
          src: "assets/images/5.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
    ],
  },
  {
    id: "6",
    colors: [],
    favorite: false,

    description: {
      product: {
        text: "Nike Revolution 5 BQ3210 men's running shoe",
      },
      brand: {
        text: "Nike",
      },
      sports: {
        text: "Running",
      },
    },

    productItems: [
      {
        id: "1",
        image: {
          src: "assets/images/6.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "Promo", color: "black" },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 15,
          rating: 4,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
    ],
  },
];

export const productCardComparisonData: IProductCardData<HTMLLinkElement> = {
  id: "111",
  colors: ["black"],

  description: {
    product: {
      text: "Nike Revolution 5 BQ3204 men's running shoe",
      href: "/",
    },
    brand: {
      text: "Nike",
      href: "/",
    },
    sports: {
      text: "Running",
    },
  },
  productItems: [
    {
      id: "1",
      image: {
        src: "assets/images/1.jpg",
      },
      prices: deepClone(mockedPricesMainOnly),
    },
  ],
};

export const productCardCustomMedia: IProductCardData<HTMLLinkElement> = {
  id: "111",
  colors: ["black"],

  description: {
    product: {
      text: "Nike Revolution 5 BQ3204 men's running shoe",
      href: "/",
    },
    brand: {
      text: "Nike",
      href: "/",
    },
    sports: {
      text: "Running",
    },
  },
  productItems: [
    {
      id: "1",
      image: null,
      prices: deepClone(mockedPricesMainOnly),
    },
  ],
};

export const productCardCustomImage: IProductCardData<HTMLLinkElement> = {
  id: "333",
  colors: ["black", "white", "red"],

  description: {
    product: {
      text: "Nike Revolution 5 BQ3204 men's running shoe",
      href: "/",
    },
    brand: {
      text: "Nike",
      href: "/",
    },
    sports: {
      text: "Running",
    },
  },
  productItems: [
    {
      id: "1",
      prices: deepClone(mockedPricesMainOnly),
    },
    {
      id: "2",
      prices: deepClone(mockedPricesMainOnly),
    },
    {
      id: "3",
      prices: deepClone(mockedPricesMainOnly),
    },
  ],
};

export const productCardActiveItem: IProductCardData<HTMLLinkElement>[] = [
  {
    id: "111",
    colors: ["black", "white", "red"],
    favorite: false,

    description: {
      product: {
        text: "Nike Revolution 5 BQ3204 men's running shoe",
        href: "/",
      },
      brand: {
        text: "Nike",
        href: "/",
      },
      sports: {
        text: "Running",
      },
    },

    productItems: [
      {
        id: "1",
        isActive: true,
        image: {
          src: "assets/images/1.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "-20%", color: "red" },
          { text: "Recyclable", color: "green" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "20",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "2",
        image: {
          src: "assets/images/2.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 100,
          rating: 4,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "3",
        image: {
          src: "assets/images/3.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
        ],
        feedback: {
          reviews: 29,
          rating: 3.8,
        },
        prices: [
          {
            price: "50",
            currency: "€",
          },
        ],
      },
    ],
  },
  {
    id: "222",
    colors: ["black", "white", "red"],
    favorite: false,

    description: {
      product: {
        text: "Nike Revolution 5 BQ3204 men's running shoe",
        href: "/",
      },
      brand: {
        text: "Nike",
        href: "/",
      },
      sports: {
        text: "Running",
      },
    },

    productItems: [
      {
        id: "1",
        image: {
          src: "assets/images/1.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "-20%", color: "red" },
          { text: "Recyclable", color: "green" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "20",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "2",
        isActive: true,
        image: {
          src: "assets/images/2.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 100,
          rating: 4,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "3",
        image: {
          src: "assets/images/3.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
        ],
        feedback: {
          reviews: 29,
          rating: 3.8,
        },
        prices: [
          {
            price: "50",
            currency: "€",
          },
        ],
      },
    ],
  },
  {
    id: "333",
    colors: ["black", "white", "red"],
    favorite: false,

    description: {
      product: {
        text: "Nike Revolution 5 BQ3204 men's running shoe",
        href: "/",
      },
      brand: {
        text: "Nike",
        href: "/",
      },
      sports: {
        text: "Running",
      },
    },

    productItems: [
      {
        id: "1",
        image: {
          src: "assets/images/1.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "-20%", color: "red" },
          { text: "Recyclable", color: "green" },
        ],
        feedback: {
          reviews: 15,
          rating: 4.5,
        },
        prices: [
          {
            price: "20",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "2",
        image: {
          src: "assets/images/2.jpg",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
          { text: "-10%", color: "red" },
        ],
        feedback: {
          reviews: 100,
          rating: 4,
        },
        prices: [
          {
            price: "10",
            currency: "€",
          },
          {
            price: "50",
            currency: "€",
            variant: "original",
          },
        ],
      },
      {
        id: "3",
        isActive: true,
        image: {
          src: "assets/images/3.jpg",
          alt: "my own alt",
        },
        badges: [
          {
            text: "Best Choice",
            color: "blue",
          },
        ],
        feedback: {
          reviews: 29,
          rating: 3.8,
        },
        prices: [
          {
            price: "50",
            currency: "€",
          },
        ],
      },
    ],
  },
];
